'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div data-component-id="src/app/news-updates/components/CategoryFilter.tsx:25:4" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="25" data-component-file="CategoryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border%20border-border%20rounded-lg%20p-6%20shadow-minimal%22%7D" className="bg-card border border-border rounded-lg p-6 shadow-minimal">
      <h3 data-component-id="src/app/news-updates/components/CategoryFilter.tsx:26:6" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="26" data-component-file="CategoryFilter.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22Kategorije%22%7D" className="text-lg font-semibold text-foreground mb-4">Kategorije</h3>
      <div data-component-id="src/app/news-updates/components/CategoryFilter.tsx:27:6" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="27" data-component-file="CategoryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" className="space-y-2">
        {categories.map((category) => (
          <button data-component-id="src/app/news-updates/components/CategoryFilter.tsx:29:10" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="29" data-component-file="CategoryFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-smooth ${
              activeCategory === category.id
                ? 'bg-primary text-white' :'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            <div data-component-id="src/app/news-updates/components/CategoryFilter.tsx:37:12" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="37" data-component-file="CategoryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%22%7D" className="flex items-center space-x-3">
              <Icon data-component-id="src/app/news-updates/components/CategoryFilter.tsx:38:14" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="38" data-component-file="CategoryFilter.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                name={category.icon as any}
                size={20}
                className={activeCategory === category.id ? 'text-white' : 'text-primary'}
              />
              <span data-component-id="src/app/news-updates/components/CategoryFilter.tsx:43:14" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="43" data-component-file="CategoryFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-medium%22%7D" className="font-medium">{category.name}</span>
            </div>
            <span data-component-id="src/app/news-updates/components/CategoryFilter.tsx:45:12" data-component-path="src/app/news-updates/components/CategoryFilter.tsx" data-component-line="45" data-component-file="CategoryFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`text-sm px-2 py-1 rounded-full ${
                activeCategory === category.id
                  ? 'bg-white/20 text-white' :'bg-primary/10 text-primary'
              }`}
            >
              {category.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;